import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import Alert from "../../../Common/Alert";
import DatatableFunc from "../../../Common/DatatableFunc";
import Http from "../../../Common/Http";
import IsLogin from "../../../Common/IsLogin";
import { LoaderComponent } from "../../../Common/LoaderComponent";
import Swal from "sweetalert2";

const Show = () => {
  const [receiveData, setReceiveData] = useState([]);
  const { id } = useParams();
  const [alert, setAlert] = useState(null);
  const location = useLocation();
  const [role, setRole] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    DatatableFunc();
  }, []);

  const fetchData = async () => {
    const resRole = await Http.get(`/staff-type-check`);
    setRole(resRole.data);
    Http.get(`/requisition-production/${id}`).then((res) => {
      setReceiveData(res.data);
    });
  };

  useEffect(() => {
    DatatableFunc();
    fetchData();
  }, []);

  const showAlert = (message, type) => {
    setAlert({ message, type });
    setTimeout(() => {
      setAlert(null);
    }, 4000);
  };

  useEffect(() => {
    if (!location.state) return;
    showAlert(location.state.message, location.state.type);
  }, [location]);

  const approveRequisition = (reqId) => {
    if (role !== "gm") return;

    Swal.fire({
      title: "Are you sure?",
      text: "You want to approve this requisition production?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, approve it!",
    }).then((result) => {
      if (result.isConfirmed) {
        Http.post(`/approve-requisition-production/${reqId}`).then((res) => {
          setReceiveData(res.data);
          Swal.fire("Approved!", "Requisition Production has been approved.", "success");
          navigate("/requisition-production");
        });
      }
    });
  };

  const receiveItem = (reqId) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, receive it!",
    }).then((result) => {
      if (result.isConfirmed) {
        Http.post(`/receive-requisition-production/${reqId}`).then((res) => {
          setReceiveData(res.data);
          navigate("/requisition-production-with-batch");
          Swal.fire("Received!", "Item has been received.", "success");
        });
      }
    });
  };

  const print = () => window.print();

  return (
    <div>
      <IsLogin></IsLogin>
      <LoaderComponent />
      <style>
        {`
              @media print {
                  body * { visibility: hidden; font-size:10px;}
                  .no-print { visibility: hidden !important; }
                  #printable-content, #printable-content * { visibility: visible; }
                  #printable-content { position: absolute; left: 0; top: 0; width: 100%; }
                  .main-card { padding: 0px; }
                  .am-pagebody { padding: 0px; }
                  .am-mainpanel { margin-top: 0px; }
                  .signature_section .table td{ border-bottom: 0;}
              }
              .main-card { padding: 40px; }
            `}
      </style>

      <div className="am-mainpanel">
        <div className="am-pagetitle">
          <h5 className="am-title">Requisition Production With Batch Size</h5>
        </div>

        <div className="am-pagebody">
          <Alert alert={alert} />
          <div className="card card-primary card-outline">
            <div className="card-header no-print">
              <div className="row">
                <div className="col-md-7">
                  <h4 className="card-title">Requisition Production - {receiveData.batch_no}</h4>
                </div>
                <div className="col-md-5 text-right">
                  <button className="btn btn-default" onClick={print}>
                    <i className="fa fa-print"></i>
                    &nbsp;Print
                  </button>
                </div>
              </div>
            </div>

            <div className="card-body main-card" id="printable-content">
              <div className="row">
                <div className="col-md-12">
                  <table className="table">
                    <tbody>
                      <tr>
                        <td style={{ border: "none" }} align="center">
                          <h2 className="text-uppercase">Nabil Restaurant</h2>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              {/* <div className="row">
                <div className="col-md-12">
                  <table className="table table-sm">
                    <tbody>
                      <tr>
                        <td width="30%">
                          {receiveData.created_by ? receiveData.created_by.name : ""}
                          <br />
                          {receiveData.created_by ? receiveData.created_by.department?.name : ""}
                        </td>
                        <td width="35%" align="right">
                          Order Date: {receiveData.date}
                          <br />
                          Time: {receiveData.time}
                          <br />
                          Receipt No: {receiveData.batch_no}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div> */}
              <div className="row mb-4">
                <div className="col-sm-12">
                  <div className="rounded-3 border bg-light">
                    <div className="">
                      <div className="">
                        <div className="row g-2 p-1">
                          {receiveData.requisition_product_groups && receiveData.requisition_product_groups.length > 0 ? (
                            receiveData.requisition_product_groups.map((group, index) => (
                              <div className="col-md-6" key={group.id}>
                                <div className="">
                                  <div className="">
                                    <span className="text-muted">Recipe Name:</span> <span className="fw-semibold">{group?.product_group?.name || "-"} <br /></span>
                                    <span className="text-muted">Batch Size:</span> <span className="fw-semibold">{group.batch_size || "-"} <br /></span>
                                    <span className="text-muted">Products:</span>  <span>{group.product_group?.group_items && group.product_group?.group_items.length > 0 ? group.product_group?.group_items?.map((item) => item.products?.name).join(", ") : "-"}</span>
                                  </div>
                                </div>
                              </div>
                            ))
                          ) : (
                            <div className="col-md-3">
                              <span className="text-muted">no groups available</span>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <table className="table">
                    <tbody>
                      <tr>
                        <td align="center">
                          <h5>
                            <u>Requisition Production</u>
                          </h5>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="row">
                <div className="col-md-12">
                  <table className="table table-bordered table-sm">
                    <tbody>
                      <tr>
                        <th width="3%">sl.</th>
                        <th width="10%">Code</th>
                        <th width="20%">Item Name</th>
                        <th width="10%"> Qty</th>
                        <th width="10%"> Unit</th>
                        {/* <th width="10%">Price</th>
                        <th width="10%">Amount</th> */}
                      </tr>
                      {receiveData.items && receiveData.items.length > 0 ? (
                        receiveData.items.map((item, index) => (
                          <tr key={item.id}>
                            <td>{index + 1}</td>
                            <td>{item.product ? item.product?.code : ""}</td>
                            <td>{item.product ? item.product?.name : ""}</td>
                            <td>{item.qty}</td>
                            <td>{item.product ? (item?.product?.unit?.name ?? '-') : ""}</td>

                            {/* <td align="right">{Number(item.rate || 0).toFixed(2)}</td>
                            <td align="right">{(Number(item.rate || 0) * Number(item.qty || 0)).toFixed(2)}</td> */}
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="6" align="center">
                            No items available
                          </td>
                        </tr>
                      )}

                    </tbody>
                  </table>
                </div>
              </div>

              {/* <div className="row">
                <div className="col-md-12">
                  <table className="table" style={{ width: "100%" }}>
                    <tbody>
                      <tr>
                        <td width="30%" align="center" style={{ borderTop: "none" }}>
                          <br />
                          <br />
                          <br />
                          ......................................................
                          <br />
                          Prepared By
                        </td>
                        <td width="10%" style={{ borderTop: "none" }}>
                          &nbsp;
                        </td>
                        <td width="30%" align="center" style={{ borderTop: "none" }}>
                          <br />
                          <br />
                          <br />
                          ......................................................
                          <br />
                          Checked By
                        </td>
                        <td width="10%" style={{ borderTop: "none" }}>
                          &nbsp;
                        </td>
                        <td width="30%" align="center" style={{ borderTop: "none" }}>
                          <br />
                          <br />
                          <br />
                          ......................................................
                          <br />
                          Approved By
                        </td>
                        <td width="10%" style={{ borderTop: "none" }}>
                          &nbsp;
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div> */}

              <div className="mt-3 d-flex flex-wrap gap-2 no-print">
                {!receiveData.approved_by && role === "gm" && (
                  <button type="button" className="btn btn-success btn-sm px-3 shadow-sm" onClick={() => approveRequisition(id)}>
                    <i className="fa fa-check me-1"></i> Approve
                  </button>
                )}

                {role === "production" && receiveData.issue && receiveData.issue.rmpm_receive_status !== 1 && (
                  <button type="button" onClick={() => receiveItem(id)} className="btn btn-primary btn-sm px-3 shadow-sm">
                    <i className="fa fa-download me-1"></i> Confirm Received
                  </button>
                )}

                {role === "supply_chain" && receiveData.approved_by && !receiveData.issue && (
                  <Link className="btn btn-outline-primary btn-sm px-3 shadow-sm" to={{ pathname: "/create-issue/" + id }}>
                    <i className="fa fa-send me-1"></i> Go To Release Screen
                  </Link>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Show;
